import { useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';

export function useDateFormatter(): (startDate: Date, endDate: Date) => string {
  const { t } = useTranslation('ApplicationWarnings');
  const language: string = useScopedSelector('/language.locale');
  const local = language.startsWith('fr') ? 'fr-CA' : 'en-CA';

  const timeFormatter = Intl.DateTimeFormat(local, { timeStyle: 'short' });
  const dateFormatter = Intl.DateTimeFormat(local, { month: 'long', day: 'numeric' });

  return (startDate: Date, endDate: Date) => {
    const date = dateFormatter.format(startDate);
    const startTime = timeFormatter.format(startDate);
    if (endDate) {
      const endTime = timeFormatter.format(endDate);
      return `${date} ${t('from')} ${startTime} ${t('to')} ${endTime}`;
    }
    return `${date} ${t('at')} ${startTime}`;
  };
}
